
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/meilleures-ventes",
      function () {
        return require("private-next-pages/meilleures-ventes.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/meilleures-ventes"])
      });
    }
  